import Banner from "../Banner/Banner";
import Footer from "../Footer/Footer";
import Section1 from "../Section1/Section1";
import Section2 from "../Section2/Section2";
import Section3 from "../Section3/Section3";
import Faq from "../Pages/Faq/Faq";
import "./Home.css";
import { AllPlatform } from "../Pages/AllPlatformsInfo/AllPlatform";
import SeoJson from "../SeoJson";
import translation from "../Translations/translation.json";
import { Helmet } from "react-helmet-async";
import { useLanguage } from "../LanguageContext";

const Home = () => {
  const { language } = useLanguage();

  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const url = "https://powdex.io/";
  const title = `${translate("titleBar.homeTitle")}`;
  // "PoWDex — Decentralized Exchange on ETHW";
  const desc =
    "Swap tokens on EthereumPoW (ETHW) with fast, non-custodial execution. Select a token, set Sell/Buy amounts, and get started on PoWDex.";
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={url} />

        {/* OG / Twitter */}
        <meta property="og:site_name" content="PoWDex" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={url} />
        <meta
          property="og:image"
          content="https://powdex.io/https://res.cloudinary.com/dbtsrjssc/image/upload/v1734153508/powdex_svg_165_ym6eui.svg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* ===== JSON-LD ===== */}

      {/* Organization (brand) */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "PoWDex",
          url,
          logo: "https://powdex.io/https://res.cloudinary.com/dbtsrjssc/image/upload/v1734153508/powdex_svg_165_ym6eui.svg",
          sameAs: [
            "https://epow.io",
            "https://powtools.io",
            "https://strongmoon.com",
          ],
        }}
      />

      {/* Website + Sitelinks search */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          url,
          potentialAction: {
            "@type": "SearchAction",
            target: "https://powdex.io/search?q={query}",
            "query-input": "required name=query",
          },
        }}
      />

      {/* Primary actions as a list (Swap is the core CTA) */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              item: {
                "@type": "WebApplication",
                name: "Swap",
                url: "https://powdex.io/swap",
                description: "Swap ETHW tokens instantly with your wallet.",
                operatingSystem: "Web",
                applicationCategory: "FinanceApplication",
              },
            },
            {
              "@type": "ListItem",
              position: 2,
              item: {
                "@type": "WebApplication",
                name: "Create Pair",
                url: "https://powdex.io/createPool",
                description: "Launch a new ETHW trading pool.",
                operatingSystem: "Web",
                applicationCategory: "FinanceApplication",
              },
            },
            {
              "@type": "ListItem",
              position: 3,
              item: {
                "@type": "WebApplication",
                name: "Add Liquidity",
                url: "https://powdex.io/createPool",
                description: "Provide liquidity and earn trading fees.",
                operatingSystem: "Web",
                applicationCategory: "FinanceApplication",
              },
            },
          ],
        }}
      />

      {/* Optional: tiny HowTo for “Get Started” */}
      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "HowTo",
          name: "How to start swapping on PoWDex (ETHW)",
          step: [
            {
              "@type": "HowToStep",
              name: "Connect wallet on ETHW",
              text: "Open PoWDex, connect MetaMask (EthereumPoW network).",
            },
            {
              "@type": "HowToStep",
              name: "Select a token",
              text: "Choose the token you want to swap in the 'Please select a token' field.",
            },
            {
              "@type": "HowToStep",
              name: "Enter amounts",
              text: "Set Sell and Buy amounts, review slippage and price impact.",
            },
            {
              "@type": "HowToStep",
              name: "Confirm swap",
              text: "Click Get Started/Swap and confirm the transaction in your wallet.",
            },
          ],
        }}
      />

      {/* ===== Page UI ===== */}
      <main>
        <Banner />
        {/* <Section1 />
      <Section2 />
      <Section3 /> */}
        <Faq />
        <AllPlatform />
        {/* <Footer /> */}
      </main>
    </>
  );
};

export default Home;
